import axios from 'axios';
import { config } from '@/config';
import { MULTI_AGENTS_API_URL } from '@/config/api';

const instance = axios.create({
  baseURL: MULTI_AGENTS_API_URL,
  headers: {
    brand: config.COUNTRY,
    'Content-Type': 'application/json',
  },
});

const multiAgents = {
  instance,
  get: ({ url, headers, params }) => {
    const requestConfig = {
      headers: {
        ...instance.defaults.headers,
        ...headers,
      },
    };
    if (params) {
      requestConfig.params = params;
    }
    return instance.get(url, requestConfig);
  },
  post: ({ url, headers, data }) => {
    const requestConfig = {
      headers: {
        ...instance.defaults.headers,
        ...headers,
      },
    };
    return instance.post(url, data, requestConfig);
  },
  delete: ({ url, headers }) => {
    const requestConfig = {
      headers: {
        ...instance.defaults.headers,
        ...headers,
      },
    };
    return instance.delete(url, requestConfig);
  },
};

export default multiAgents;
